<template>
  <b-form-group label="Hide controls by table">
    <div v-for="(row, index) in rows" :key="row.key" class="form-row mb-2 align-items-start">
      <div class="col-md-4 mb-1">
        <b-form-select :value="row.tableId" :options="tableOptions(row)" aria-label="Table"
          @change="row.tableId = $event; publish()" />
      </div>
      <div class="col-md-7 mb-1">
        <multiselect v-model="row.controls" :options="controls" :multiple="true"
          :hide-selected="true" placeholder="Show all controls" @input="publish" />
      </div>
      <div class="col-md-1">
        <b-button variant="outline-danger" title="Remove table override" aria-label="Remove table override"
          @click="rows.splice(index, 1); publish()"><i class="fas fa-times"></i></b-button>
      </div>
    </div>
    <b-button variant="outline-primary" size="sm" title="Add table override" @click="addRow">
      <i class="fas fa-plus"></i> Table
    </b-button>
  </b-form-group>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  props: {
    value: { type: [Object, Array], default: () => ({}) },
    controls: { type: Array, default: () => [] },
  },
  data: () => ({ rows: [], nextKey: 0 }),
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (JSON.stringify(value || {}) === JSON.stringify(this.toMap())) return;
        this.rows = Object.entries(value || {}).map(([tableId, controls]) => ({
          key: ++this.nextKey, tableId: String(tableId), controls: Array.isArray(controls) ? [...controls] : [],
        }));
      },
    },
  },
  methods: {
    toMap() {
      return Object.fromEntries(this.rows.filter(row => /^\d+$/.test(String(row.tableId)) && +row.tableId > 0)
        .map(row => [String(+row.tableId), [...row.controls]]));
    },
    publish() { this.$emit('input', this.toMap()); },
    addRow() { this.rows.push({key: ++this.nextKey, tableId: null, controls: []}); },
    tableOptions(row) {
      const used = this.rows.filter(item => item !== row).map(item => String(item.tableId));
      const options = (this.$store.getters['tablesForSelect/list'] || [])
        .filter(item => !used.includes(String(item.value)))
        .map(item => ({value: String(item.value), text: item.value + ' - ' + item.label}));
      if (row.tableId && !options.some(item => item.value === String(row.tableId))) {
        options.push({value: String(row.tableId), text: String(row.tableId)});
      }
      return [{value: null, text: 'Select table', disabled: true}, ...options];
    },
  },
};
</script>
